if (!customElements.get("search-component")) {
  customElements.define(
    "search-component",
    class extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("[data-search-component-input]");
        if (!this.input) return;

        this.items = this.querySelectorAll("li");

        this.input.addEventListener("input", this.onInput.bind(this));
        this.input.addEventListener("change", this.onChange.bind(this));
        this.input.addEventListener("blur", this.onBlur.bind(this));
      }

      onChange(event) {
        event.stopPropagation();
      }

      onBlur(event) {
        event.stopPropagation();
      }

      onInput() {
        const searchValue = this.input.value.trim().toLowerCase();
        const searching = searchValue !== "";

        this.items.forEach((item) => {
          const label = item.querySelector("label");
          if (!label) return;

          const labelText = label.querySelector(".reversed-link__text");
          const itemText = labelText
            ? labelText.textContent.trim().toLowerCase()
            : label.textContent.trim().toLowerCase();
          const matches = !searching || itemText.includes(searchValue);

          // `.show-more-item` is collapsed behind show-more-button's own `.hidden` toggle, so a
          // search match there needs that class actually removed, not just out-matched by
          // `.search-hidden` — remember the pre-search state once so clearing the search restores
          // whatever collapsed/expanded state show-more-button already had.
          if (item.classList.contains("show-more-item")) {
            if (searching) {
              if (item.dataset.searchCollapsed === undefined) {
                item.dataset.searchCollapsed = item.classList.contains("hidden") ? "1" : "0";
              }
              item.classList.remove("hidden");
            } else if (item.dataset.searchCollapsed !== undefined) {
              item.classList.toggle("hidden", item.dataset.searchCollapsed === "1");
              delete item.dataset.searchCollapsed;
            }
          }

          // `.search-hidden` is a pure overlay (see collection.css) on top of that `.hidden`
          // toggle — never touch `item.style.display` here, it can't win against either class.
          item.classList.toggle("search-hidden", !matches);
        });

        // The button's own expand/collapse toggle would fight the force-expand above (and its
        // label would desync) if clicked mid-search — hide it while searching, restore untouched
        // (still whatever expand state it already had) once the search clears.
        const moreButton = this.closest(".parent-display")?.querySelector("show-more-button");
        if (moreButton) moreButton.classList.toggle("search-hidden", searching);
      }
    }
  );
}
